import style from './style.css';

const TestimonialCard = ({ name, desc, male }) => {
  return (
    <div className={style.testimonialCard}>
      <div className={style.leftCard}>
        <img
          src={
            male
              ? 'https://iccdn.in/campaigns/page/profile-male.png'
              : 'https://iccdn.in/campaigns/page/profile-female.png'
          }
          className={style.cardImage}
        />
      </div>
      <div className={style.rightCard}>
        <div className={style.cardName}>{name}</div>
        <div className={style.cardDesc}>{`\"${desc}\"`}</div>
      </div>
    </div>
  );
};

export default TestimonialCard;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/testimonials/testimonialCard/index.js